"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWeight = createWeight;
const events_1 = require("../../../events");
const queries_1 = require("../queries");
function createWeight({ formatNumber }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries.weight);
    if (event === undefined) {
        return { value: "-" };
    }
    return {
        value: `${formatNumber(event.value)} Kg`,
        timestamp: event.timestamp,
        origin: event.origin
    };
}
